import React from 'react'

export const EmptyCart = () => {
    return (
        <div className='cart-empty'>
            <p>Your cart is currently empty!</p>
        </div>
    )
}
